import type { MorphemeDetailsTileSlice } from "@-/dev.improve.haniverse.lib.morpheme.entities";

export function orderDeckCardsByCharacterList(
  characterList: string[],
  cardList: MorphemeDetailsTileSlice[],
): MorphemeDetailsTileSlice[] {
  const cardByFrontDict = new Map(cardList.map((card) => [card.front, card]));
  return characterList.flatMap((front) => {
    const card = cardByFrontDict.get(front);
    return card === undefined ? [] : [card];
  });
}
